"use client";

import React, { useEffect, useState } from "react";
import Link from "next/link";
import { Icon } from "@iconify/react";
import useAuthInfo from "@/store/auth";
import { AjaxGet } from "@/util/Ajax";

export default function HomeTrialBanner() {
  const userData = useAuthInfo((state) => state);
  const [hydrated, setHydrated] = useState(false);
  const [canClaim, setCanClaim] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const hydrate = async () => {
      await useAuthInfo.persist.rehydrate();
      if (isMounted) setHydrated(true);
    };

    hydrate();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (!hydrated) return;

    // Logged out visitors still get the pitch — eligibility is checked once they sign in.
    if (!userData.apiToken) {
      setCanClaim(true);
      return;
    }

    let isMounted = true;
    AjaxGet(userData, "Discover/CanClaimTrial").then((res) => {
      if (isMounted) setCanClaim(res?.data === true);
    });

    return () => {
      isMounted = false;
    };
  }, [hydrated, userData.apiToken]);

  if (!hydrated || !canClaim) return null;

  return (
    <section className="container mx-auto max-w-6xl px-4 py-10">
      <div className="flex flex-col items-start gap-5 rounded-3xl border border-cyan-200 bg-gradient-to-br from-cyan-50 via-white to-slate-50 p-6 shadow-sm md:flex-row md:items-center md:justify-between dark:border-cyan-900/50 dark:from-cyan-950/30 dark:via-slate-900 dark:to-slate-900">
        <div className="flex items-start gap-4">
          <span className="rounded-2xl bg-cyan-600/10 p-3 text-cyan-600">
            <Icon icon="heroicons:gift" className="text-2xl" />
          </span>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-600">
              Discovery
            </p>
            <h2 className="mt-1 text-2xl font-bold text-slate-900 dark:text-white">
              Get your business online for free
            </h2>
            <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">
              Free-listing offer for eligible accounts. No card required. Offer expiry and terms apply.{" "}
              <Link href="/business-listing-pricing" className="underline underline-offset-4">Compare listing options</Link>.
            </p>
          </div>
        </div>

        <Link
          href="/discover/create?plan=trial"
          className="rounded-xl bg-cyan-600 px-6 py-3 text-sm font-semibold text-white transition hover:bg-cyan-700"
        >
          Claim your free listing
        </Link>
      </div>
    </section>
  );
}
